import Model from '@/models/Model.js';

export default class TranscriptExcerpt extends Model {
    static entity = 'transcript_excerpts';

    static fields() {
        return {
            id: this.attr(null),
            meeting_id: this.attr(null),
            meeting_recording_id: this.attr(null),
            start: this.number(null),
            end: this.number(null),
            content: this.attr(null),

            ...super.fields(),

            meeting: this.belongsTo('meetings', 'meeting_id'),
            meeting_recording: this.belongsTo('meeting_recordings', 'meeting_recording_id'),
        };
    }

    get start_time() {
        return TranscriptExcerpt.secondsToTime(this.start);
    }

    get end_time() {
        return TranscriptExcerpt.secondsToTime(this.end);
    }

    static secondsToTime(time) {
        const sec_num = parseInt(time, 10); // don't forget the second param
        let hours = Math.floor(sec_num / 3600);
        let minutes = Math.floor((sec_num - hours * 3600) / 60);
        let seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = `0${hours}`;
        }
        if (minutes < 10) {
            minutes = `0${minutes}`;
        }
        if (seconds < 10) {
            seconds = `0${seconds}`;
        }
        return `${hours}:${minutes}:${seconds}`;
    }
}
